import { OptionProps } from '@welbe/web-design-system/lib/components/molecules/InputSelect/InputSelect.types';
import { useEffect, useState } from 'react';
import { getBranchOffices, getInsurance } from 'services/filters';
import { BranchOffices, Insurance } from 'types';

type SelectProps = {
	id: string;
	value: string;
};

const clearOption = {
	id: ' ',
	value: 'Seleccione...',
};

export const useFilters = () => {
	const [isLoadingBranchOffice, setLoadingBranchOffice] = useState(false);
	const [branchOfficeOptions, setBranchOfficeOptions] = useState<SelectProps[]>(
		[],
	);
	const [selectedBranchOffice, setSelectedBranchOffice] =
		useState<SelectProps>(clearOption);

	const [isLoadingInsurance, setLoadingInsurance] = useState(false);
	const [insuranceOptions, setInsuranceOptions] = useState<SelectProps[]>([]);
	const [selectedInsurance, setSelectedInsurance] =
		useState<SelectProps>(clearOption);
	const [selectedBusinessName, setSelectedBusinessName] = useState<OptionProps>(
		{ id: '', name: '' },
	);

	const fetchBranchOfficeOptions = async (): Promise<void> => {
		setLoadingBranchOffice(true);
		try {
			const res = await getBranchOffices();
			const { branchOffices } = res.data.content;
			const formattedBranchOffices = branchOffices.map(
				(branchOffice: BranchOffices) => ({
					id: branchOffice.id,
					value: branchOffice.name,
				}),
			);
			setBranchOfficeOptions([clearOption, ...formattedBranchOffices]);
		} catch (error) {
			console.error(error);
		} finally {
			setLoadingBranchOffice(false);
		}
	};

	const fetchInsurance = async (): Promise<void> => {
		setLoadingInsurance(true);
		try {
			const res = await getInsurance();
			const { insurances } = res.data.content;
			const formattedInsurances = insurances.map((insurance: Insurance) => ({
				id: insurance.id,
				value: insurance.name,
			}));
			setInsuranceOptions([clearOption, ...formattedInsurances]);
		} catch (error) {
			console.error(error);
		} finally {
			setLoadingInsurance(false);
		}
	};

	const handleBranchOffice = (branchOffice: SelectProps) => {
		setSelectedBranchOffice(branchOffice);
	};

	const handleInsurance = (insurance: SelectProps) => {
		setSelectedInsurance(insurance);
	};

	useEffect(() => {
		fetchBranchOfficeOptions();
		fetchInsurance();
	}, []);

	useEffect(() => {
		if (insuranceOptions.length === 2) {
			handleInsurance(insuranceOptions[1]);
		}
	}, [insuranceOptions]);

	return {
		handleBranchOffice,
		handleInsurance,
		isLoadingBranchOffice,
		branchOfficeOptions,
		selectedBranchOffice,
		isLoadingInsurance,
		insuranceOptions,
		selectedInsurance,
		selectedBusinessName,
		setSelectedBusinessName,
	};
};
